import { api_POST, api_PUT } from "services/api_service.js";
import { showMessage } from "./message";

export const EnviaProtocoloWithProtocoloDestino = (json, callback) => {
    if (json.protocolo_Id == 0) {
        api_POST('protocoloDestino/PostProtocoloWithProtocoloDestino', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
    else {
        api_PUT('protocoloDestino/PutProtocoloWithProtocoloDestino', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
}

export const EnviaProtocoloDestinoLocal = (json, callback) => {
    if (json.protocoloDestinoLocal_Id == 0) {
        api_POST('protocoloDestino/PostProtocoloDestinoLocal', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('protocoloDestino/PutProtocoloDestinoLocal', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
}

export const EnviaProtocoloDocumentoDestino = (json, callback) => {
    api_POST('protocoloDestino/PostProtocoloDocumento', json)
        .then(result => { callback(result) })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}


export const EnviaRequerimentoDestino = (json, callback) => {
    if (json.requerimentoDestino_Id == 0) {
        api_POST('requerimentoDestino/PostRequerimentoDestino', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
    else {
        api_PUT('requerimentoDestino/PutRequerimentoDestino', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
}

export const EnviaRequerimentoDestinoLocal = (json, callback) => {
    if (json.requerimentoDestinoLocal_Id == 0) {
        api_POST('requerimentoDestino/PostRequerimentoDestinoLocal ', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
    else {
        api_PUT('requerimentoDestino/PutRequerimentoDestinoLocal', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))

    }
}

export const EnviaRequerimentoDocumentoDestino = (json, callback) => {
    api_POST('requerimento/PostrequerimentoDocumento', json)
        .then(result => { callback(result) })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

